import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
import { Activity, Droplets, Sun, ScanFace, Target, Sparkles } from 'lucide-react';
export function Problems() {
  const problems = [{
    icon: <ScanFace className="w-8 h-8" data-id="element-199" />,
    title: 'Flacidez facial',
    description: 'Pérdida de firmeza y definición en el óvalo facial con el paso del tiempo.'
  }, {
    icon: <Sun className="w-8 h-8" data-id="element-200" />,
    title: 'Manchas',
    description: 'Hiperpigmentación, melasma o daño solar que afecta el tono uniforme de la piel.'
  }, {
    icon: <Activity className="w-8 h-8" data-id="element-201" />,
    title: 'Arrugas',
    description: 'Líneas de expresión dinámicas y estáticas que envejecen el rostro.'
  }, {
    icon: <Target className="w-8 h-8" data-id="element-202" />,
    title: 'Celulitis',
    description: 'Alteración del tejido subcutáneo que provoca irregularidades en la piel.'
  }, {
    icon: <Droplets className="w-8 h-8" data-id="element-203" />,
    title: 'Grasa localizada',
    description: 'Acumulación de tejido adiposo resistente a dietas y ejercicio.'
  }, {
    icon: <Sparkles className="w-8 h-8" data-id="element-204" />,
    title: 'Piel apagada',
    description: 'Falta de luminosidad, textura irregular y poros dilatados.'
  }];
  return <section className="py-24 md:py-32 bg-background" data-id="element-205">
      <div className="container mx-auto px-6 md:px-12" data-id="element-206">
        <SectionHeading title="¿Te identificas con alguna de estas situaciones?" subtitle="Entendemos tus preocupaciones. Cada condición tiene una solución médica específica y efectiva." data-id="element-207" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-16" data-id="element-208">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-209">
              <div className="bg-surface p-8 rounded-2xl border border-border shadow-sm hover:shadow-md transition-all duration-300 group" data-id="element-210">
                <div className="w-14 h-14 rounded-xl bg-champagne flex items-center justify-center text-gold mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-211">
                  {problem.icon}
                </div>
                <h3 className="font-serif text-2xl text-foreground mb-3" data-id="element-212">
                  {problem.title}
                </h3>
                <p className="text-muted-foreground font-light leading-relaxed" data-id="element-213">
                  {problem.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}